var map = {
	"./admin-settings-light.svg": 3101,
	"./admin-settings.svg": 9238,
	"./arrow-down.svg": 1759,
	"./arrow-left.svg": 5648,
	"./arrow-open.svg": 5907,
	"./arrow-up.svg": 6688,
	"./calendar.svg": 5033,
	"./clipboard.svg": 5543,
	"./copy.svg": 8552,
	"./dashboard.svg": 7461,
	"./dashboardRequest/access-manage.svg": 7147,
	"./dashboardRequest/access-request.svg": 8234,
	"./delete-left-solid.svg": 570,
	"./doc_icon.svg": 8077,
	"./drop-filter.svg": 1651,
	"./file-edit.svg": 3038,
	"./filter-remove.svg": 1514,
	"./manager-dashboard.svg": 4955,
	"./manager-groups.svg": 2133,
	"./manager-roles.svg": 2064,
	"./navbar.svg": 3645,
	"./pdf.svg": 7523,
	"./pencil-edit.svg": 1185,
	"./sitemap.svg": 7092,
	"./warning.svg": 2865
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5853;